import { createContext, useContext } from 'react';

export const ContentContext = createContext();

const useContent = () => useContext(ContentContext);

export default useContent;
